module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Articles","button":"Add an article"}}')
  delete Component.options._Ctor
}
